import { WebhooksIntegration, WebhooksIntegrationInput } from "types/generated";

import { type WebhookFormFields } from ".";

export const getFormDefaultValues = (
  webhook: WebhooksIntegration | undefined,
  isEditMode: boolean
): WebhookFormFields => ({
  endpoint: webhook?.endpoint || "",
  secret: "",
  enabled: isEditMode ? !!webhook?.enabled : true,
  retryOnFailure: isEditMode? !!webhook?.retryOnFailure : false,
});

export const mapCreateWebhookInput = (
  formData: WebhookFormFields,
  isCreateMode = true
): WebhooksIntegrationInput => {
  return {
    endpoint: formData.endpoint.trim(),
    secret: isCreateMode ? formData.secret : null,
    enabled: formData.enabled,
    retryOnFailure: formData.retryOnFailure,
  };
};
